<template>
    <default-layout>
        <div class="row">
            <div class="col-12">
                <div class="btn-toolbar float-right" role="toolbar" aria-label="Orders toolbar">
                    <div class="btn-group mr-2" role="group" aria-label="Orders toolbar, first group">
                        <button type="button" class="btn-sm page-link mr-2" @click="onRefresh">
                            <font-awesome-icon class="mr-1" icon="sync"/>
                            Refresh
                        </button>
                        <button type="button" class="btn-sm page-link" @click="exportCsv" title="Export CSV">
                            <font-awesome-icon class="mr-1" icon="file-csv"/>
                            Export CSV
                        </button>
                    </div>
                </div>
                <h1 class="h4 mb-4 clearfix">
                    Projects
                    <span class="badge badge-pill badge-primary" v-if="projects.length > 0">{{ projects.length }}</span>
                </h1>
            </div>
        </div>

        <div class="row" v-if="interactiveLinkModule.status.listProjectsComplete === false">
            <div class="col-12">
                <spinner-component class="p-5" type="spinner-grow"/>
            </div>
        </div>

        <div class="row" v-if="interactiveLinkModule.status.listProjectsComplete === true">
            <div class="col-12 clearfix">
                <pagination-component :page="page" :limit="limit" :total="projects.length" @paginate="onChangePage"/>

                <div class="table-responsive">
                    <table id="orders" class="table">
                        <thead>
                        <tr>
                            <th>Name</th>
                            <th>Status</th>
                            <th>Type</th>
                            <th>Live Usage</th>
                        </tr>
                        </thead>
                        <tbody>

                        <tr v-for="project of interactiveLinkModule.projects" :key="project.id">
                            <td class="align-middle">{{ project.descLong }}</td>
                            <td class="align-middle">
                                <span class="badge" :class="getStatusClass(project.status)">
                                    {{ getStatusLabel(project.status) }}
                                </span>
                            </td>
                            <td class="align-middle">
                                <span class="badge" :class="getTypeClass(project.type)">
                                    {{ getTypeLabel(project.type) }}
                                </span>
                            </td>
                            <td class="align-middle">{{ project.liveUsage }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </default-layout>
</template>

<script>
    import DefaultLayout from "../components/layout/DefaultLayout";
    import SpinnerComponent from "../components/ui/SpinnerComponent";
    import PaginationComponent from "../components/PaginationComponent";
    import moment from "moment";

    export default {
        name: "ProjectsPage",
        components: {PaginationComponent, SpinnerComponent, DefaultLayout },
        computed: {
            interactiveLinkModule() {
                return this.$store.state.interactiveLink;
            },
            projects() {
                return this.$store.state.interactiveLink.projects;
            }
        },
        data() {
            return {
                search: '',
                limit: 10,
                page: 1
            }
        },
        methods: {
            onRefresh() {
                this.$store.dispatch('interactiveLink/clearProjects');
                this.$store.dispatch('interactiveLink/listProjects');
            },
            onChangePage(page) {
                if (page <= 0) {
                    return;
                }

                this.page = parseInt(page);
                this.onRefresh();
            },
            exportCsv() {
                let exportData = [];
                let csvContent = "data:text/csv;charset=utf-8,";

                this.projects.forEach(project => {
                    exportData.push({
                        PROJECT_ID: project.id,
                        PROJECT_DESC_SHORT: project.descShort,
                        PROJECT_DESC_LONG: project.descLong,
                        PROJECT_STATUS: project.status,
                        PROJECT_TYPE: project.type
                    });
                });

                csvContent += [
                    Object.keys(exportData[0]).join(";"),
                    ...exportData.map(project => Object.values(project).join(";"))
                ]
                    .join("\n")
                    .replace(/(^\[)|(\]$)/gm, "");

                const data = encodeURI(csvContent);
                const link = document.createElement("a");
                link.setAttribute("href", data);
                link.setAttribute("download", "interactive-link-export-projects-" + moment().format('YYYYMMDD-HHMMSS') + ".csv");
                link.click();
            },
            getStatusClass(status) {
                switch (status) {
                    case 'PROJECT_ACTIVE':
                        return 'badge-primary';
                    case 'PROJECT_INACTIVE':
                        return 'badge-light';
                    default:
                        return 'badge-invert'
                }
            },
            getStatusLabel(status) {
                switch (status) {
                    case 'PROJECT_ACTIVE':
                        return 'Active';
                    case 'PROJECT_INACTIVE':
                        return 'Inactive';
                    default:
                        return status;
                }
            },
            getTypeClass(type) {
                switch (type) {
                    case 'PROJECT_VIDEO_ON_DEMAND':
                        return 'badge-info';
                    default:
                        return type;
                }
            },
            getTypeLabel(type) {
                switch (type) {
                    case 'PROJECT_VIDEO_ON_DEMAND':
                        return 'Video On-Demand';
                    default:
                        return type;
                }
            }
        },
        beforeMount() {
            if (this.$store.state.interactiveLink.status.listProjectsComplete === false) {
                this.$store.dispatch('interactiveLink/listProjects');
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>